import
{
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBarChart } from '@fortawesome/free-solid-svg-icons';

const Descargas = ({ labels, data: archivosDescarga, megabytes }) =>
{
    ChartJS.register
    (
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Filler,
        Legend
    );

    const options =
    {
        maintainAspectRatio: false,
        responsive: true,
        interaction:
        {
            mode: 'index',
            intersect: false,
        },
        plugins:
        {
            legend:
            {
                position: 'bottom',
                labels:
                {
                    boxWidth: 12,
                    padding: 16,
                    color: '#343a40',
                },
            },
            title:
            {
                display: false,
            },
            tooltip:
            {
                callbacks:
                {
                    label: function (context)
                    {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.y !== null) { label += context.parsed.y.toLocaleString('es-CL'); }
                        return label;
                    },
                },
            },
        },
        scales:
        {
            x:
            {
                grid:
                {
                    color: 'rgba(100, 100, 100, 0.08)',
                },
                ticks:
                {
                    color: '#343a40',
                },
            },
            y:
            {
                beginAtZero: true,
                grid:
                {
                    color: 'rgba(100, 100, 100, 0.08)',
                },
                ticks:
                {
                    color: '#343a40',
                    callback: function (value)
                    {
                        return value.toLocaleString('es-CL');
                    },
                },
            },
        },
    };

    const data =
    {
        labels: labels,
        datasets:
        [
            {
                fill: true,
                label: 'Descargas',
                data: archivosDescarga,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.25)',
                tension: 0.4,
                pointRadius: 4,
            },
            {
                fill: true,
                label: 'Megabytes',
                data: megabytes,
                borderColor: 'rgba(153, 102, 255, 1)',
                backgroundColor: 'rgba(153, 102, 255, 0.25)',
                tension: 0.4,
                pointRadius: 4,
            },
        ],
    };

    return (
        <div className="card border rounded-5 shadow-sm mb-4">
            <div className="card-header rounded-top-5 bg-white border-bottom py-3 d-flex align-items-center gap-2">
                <FontAwesomeIcon className="text-primary" icon={faBarChart} />
                {'Descargas Últimos 90 Días'}
            </div>
            <div className="card-body p-3" style={{ minHeight: '300px' }}><Line options={options} data={data} /></div>
        </div>
    )
}

export default Descargas;
